import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/jobs/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard' })
  },
})
